import { useDataStore } from '@/js/stores/DataStore.js';

const discountedUnitPrice = (row, key = 'unit_price') => {
    const unitPrice = row[key] ? parseFloat(row[key]) : 0;
    const discountValue = row.discount_value ? parseFloat(row.discount_value) : 0;

    if (row.discount_type === 'nominal') {
        return Math.max(unitPrice - discountValue, 0);
    }

    if (row.discount_type === 'percentage') {
        return Math.max(unitPrice * ((100 - discountValue) / 100), 0);
    }

    return unitPrice;
};

const subtotal = (row, key = 'unit_price') => {
    if (Array.isArray(row)) {
        return row.reduce((acc, item) => {
            return acc + subtotal(item, key);
        }, 0);
    }
    return (row.quantity ? row.quantity : 0) * discountedUnitPrice(row, key);
};

const total = (row, key = 'unit_price') => {
    if (Array.isArray(row)) {
        return row.reduce((acc, item) => {
            return acc + total(item, key);
        }, 0);
    }
    return (
        (row.quantity ? row.quantity : 0) *
        discountedUnitPrice(row, key) *
        (row.tax_rate_id ? 1 + useDataStore().get(`account.tax_rates.${row.tax_rate_id}.rate`) / 100 : 1)
    );
};

const taxAmount = (row, key = 'unit_price') => {
    if (Array.isArray(row)) {
        return row.reduce((acc, item) => {
            return acc + taxAmount(item, key);
        }, 0);
    }
    return total(row, key) - subtotal(row, key);
};

const withholdingTaxAmount = (rows, percentage, key = 'unit_price') => {
    const taxableSubtotal = subtotal(
        rows.filter((row) => !row.is_withholding_tax),
        key
    );
    const numericPercentage = Number(percentage);

    if (!Number.isFinite(numericPercentage)) {
        return 0;
    }

    return Math.abs((taxableSubtotal * numericPercentage) / 100);
};

export { subtotal, total, taxAmount, withholdingTaxAmount };
